import React from "react";

interface UIPositionProps {
  children: React.ReactNode;
  id: string;
  direction?: "row" | "column";      // layout direction
  reverse?: boolean;                 // reverse order for bottom
  align?: "start" | "end";           // alignment
  allowScreenshot?: boolean;
  containerClassName?: string;
}

const UIPosition: React.FC<UIPositionProps> = ({
                                                 children,
                                                 id,
                                                 direction = "row",
                                                 reverse = false,
                                                 align = "start",
                                                 allowScreenshot = false,
                                                 containerClassName = ""
                                               }) => {
  const flexDirection =
    direction === "row"
      ? "flex-wrap"
      : reverse
        ? "flex-column-reverse"
        : "flex-column";

  return (
    <div
      id={id}
      {...(allowScreenshot ? {} : {"data-html2canvas-ignore": ""})}
      className={containerClassName}
    >
      <div className={`d-flex ${flexDirection} align-items-${align} gap-2`}>
        {children}
      </div>
    </div>
  );
};

export const UITopLeft: React.FC<Omit<UIPositionProps, "id">> = (props) => (
  <UIPosition id="top-left" direction="row" align="start" {...props} />
);

export const UITopRight: React.FC<Omit<UIPositionProps, "id">> = (props) => (
  <UIPosition id="top-right" direction="row" align="end" {...props} />
);

export const UIBottomLeft: React.FC<Omit<UIPositionProps, "id">> = (props) => (
  <UIPosition id="bottom-left" direction="column" reverse align="start" {...props} />
);

export const UIBottomRight: React.FC<Omit<UIPositionProps, "id">> = (props) => (
  <UIPosition id="bottom-right" direction="column" reverse align="end" {...props} />
);